import React from 'react';
import PropTypes from 'prop-types';

import MotifToggleSwitch from '@ey/motif-react-wrapper/ToggleSwitch';

const ToggleSwitch = ({...rest}) => <MotifToggleSwitch {...rest} />;

ToggleSwitch.propTypes = {};

export default ToggleSwitch;
